import { GET_USER_ORGANIZATIONS } from "../actions";

export interface UserOrganization {
  uuid: string;
  display_name: string;
  role: string;
  /** True for the organization the current request resolved as. */
  active: boolean;
}

const defaultState: UserOrganization[] = [];

/**
 * The organizations the signed-in user may act as, in Scout.
 *
 * Kept separate from the `organizations` reducer, which holds the single active
 * organization's display metadata. This is the list a picker is built from, and
 * conflating the two would mean one of them silently overwriting the other.
 */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = defaultState, action: any): UserOrganization[] => {
  switch (action.type) {
    case GET_USER_ORGANIZATIONS:
      return action.payload || [];
    default:
      return state;
  }
};
